import {fetcher} from "../../../api/fetcher.js";
import {createQueryString} from "../b16/index.js";

export const getUrlParamsToString = (params, oldSearchParams) => {
  const filteredParams = Object.fromEntries(
    Object.entries(params).filter(([_, v]) => v !== null && v !== undefined),
  );

  return createQueryString(filteredParams, oldSearchParams);
};
export const handleSearchResponse = async ({
  url,
  baseApiUrl,
  slug,
  language,
  sectionData,
  fullSlug,
}) => {
  const searchTerm = url.searchParams.get("searchTerm") || slug;
  const currentPage = Number(url.searchParams.get("currentPage")) || 1;
  const filters = url.searchParams.get("filters") || "";
  const queriedSearchResponse = {};
  const paginationLink = {
    queryParams: {searchTerm, filters},
    baseUrl: fullSlug,
  };

  if (currentPage === 1 && !filters) {
    return {
      queriedSearchResponse: {
        amountResult: sectionData?.foundResults,
        localFiltersData: sectionData?.posts,
        currentPage: sectionData?.page,
        totalPage: sectionData?.maxNumPages,
        filters: +filters,
      },
      paginationLink,
    };
  }

  const filterResponse = await fetcher(
    baseApiUrl,
    `/wp-json/wp/v2/filter_search/?search=${encodeURIComponent(
      searchTerm,
    )}&page=${currentPage}&fs=${filters}&l=${language}`,
    {},
    false,
  );
  if (filterResponse.statusCode === 200) {
    queriedSearchResponse.amountResult = filterResponse.foundResults;
    queriedSearchResponse.localFiltersData = filterResponse.posts;
    queriedSearchResponse.currentPage = filterResponse.page;
    queriedSearchResponse.totalPage = filterResponse.maxNumPages;
    queriedSearchResponse.filters = +filters;
  } else {
    queriedSearchResponse.localFiltersData = [];
    queriedSearchResponse.filters = +filters;
  }

  return {
    queriedSearchResponse,
    paginationLink,
  };
};
